import { Show, createEffect, createSignal, onMount } from "solid-js";

import { Button } from "@/components/Base/Button/Button";
import Icon from "@/components/Icon";
import { useRouter } from "@/hooks/useRouter";
import { t } from "@/i18n";
import { getImgurl } from "@/lib/resFolder";
import { deviceInfo } from "@/stores/deviceStore";
import { userStore } from "@/stores/userStore";

export default function AppDownloadBanner() {
  const [visible, setVisible] = createSignal(false);
  const { push } = useRouter();

  const getTodayKey = () => {
    const d = new Date();
    return `${d.getFullYear()}-${d.getMonth() + 1}-${d.getDate()}`;
  };

  onMount(() => {
    const closedDate = localStorage.getItem("appDownloadBannerClosed");
    if (closedDate === getTodayKey()) {
      setVisible(false);
      return;
    }

    if (!userStore.isLogin) {
      setVisible(false);
      return;
    }

    if (deviceInfo.app || deviceInfo.pwa) {
      setVisible(false);
      return;
    }

    setVisible(true);
  });

  const handleClose = () => {
    localStorage.setItem("appDownloadBannerClosed", getTodayKey());
    setVisible(false);
  };

  const handleDownload = () => {
    push("/install");
    handleClose();
  };

  return (
    <Show when={deviceInfo?.app_type === 0 && visible()} fallback={<></>}>
      <div class="bg-general-bg4 border-general-searchbg fixed bottom-[45px] left-[58%] z-[500] flex max-h-[90px] w-[612px] -translate-x-1/2 flex-col items-center rounded-[10px] border p-[15px] opacity-100">
        <div class="flex h-[60px] w-full items-center gap-[15px]">
          <div class="flex items-center gap-[15px]">
            <Icon
              name="general/xx3_activity"
              color="text-[#B3B8C1]"
              class="z-[1] h-[18px] w-[18px] cursor-pointer items-center justify-center rounded-md"
              onClick={handleClose}
            />
            <img
              src={getImgurl("download-pc.png", "activity/appdownload")}
              class="h-[54.67px] w-[60px]"
              alt="app下载"
            />
          </div>

          <div class="text-general-light flex flex-1 flex-col items-start justify-center font-[inter] text-[16px] font-[500] leading-[19px]">
            {t("tips.install")} <br />
            {t("tips.install_promotions")}
          </div>
          <Button
            variant="primary"
            type="button"
            class="bg-linear-to-l from-up-mainbut-r to-up-mainbut-l text-general-butzi flex h-[40px] min-w-[99px] flex-shrink-0 items-center justify-center gap-[10px] rounded-[6px] px-[15px] text-[14px] font-[700]"
            onClick={handleDownload}
          >
            {t("install.download_button")}
          </Button>
        </div>
      </div>
    </Show>
  );
}
